<template>
  <div v-title="'首页'">
    <van-nav-bar :fixed="true"
                 title="用户协议&隐私条款" />

    <div v-loading="loading"
         class="contentStyle"
         v-html="content"></div>
  </div>
</template>

<script>
import { NavBar } from 'vant'

export default {
  name: 'termsAndPrivacy',
  components: {
    'van-nav-bar': NavBar,
  },
  data() {
    return {
      content: '',
      loading: true,
    }
  },
  mounted() {
    if (JSON.stringify(this.$route.query) != '{}') {
      let obj = this.$route.query

      this.$http
        .post(`/get_modify_terms`, {
          pro: obj.pro,
          com: obj.com,
          bd: obj.bd,
          md: obj.md,
          em: obj.em,
        })
        .then((res) => {
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
            this.loading = false
          } else if (res.data.errno == '0') {
            this.content = res.data.data
            this.loading = false
          }
        })
    } else {
      this.$http
        .post('/traver_terms', {
          method: 'get',
          content_type: 5,
        })
        .then((res) => {
          console.log(res)
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
            this.loading = false
          } else if (res.data.errno == '0') {
            this.content = res.data.data
            this.loading = false
          }
        })
    }
  },
}
</script>

<style >
html,
body,
#app {
  height: 100%;
  background-color: #fff;
}

.contentStyle {
  margin: 50px 0px;
  padding: 30px;
  font-size: medium;
}
</style>